export default __webpack_public_path__ + "static/media/beraksi-phone3.48d41d80.png";